import TileLayer from "ol/layer/Tile";
import {ImageArcGISRest, ImageWMS, TileArcGISRest, TileWMS} from "ol/source";
import {transformExtent, transform, get as getProjection} from "ol/proj";
import {callService} from "@/helpers/ol/ol-http-helper";
import ImageLayer from "ol/layer/Image";
import {
    getActiveLayers,
    getLayerAttributes,
    getLayerNamePrefix,
    removeLoaderByBookmarkPresentationID
} from "@/helpers/ol/ol-layer-helper";
import {Point} from "ol/geom";
import {getOlRotation} from "@/helpers/ol/ol-rotation-helper";
import {getToken} from "@/helpers/auth/auth-helper";
import * as TileState from "ol/TileState";
import {hideElementsBySelector} from "@/helpers/element-helper";

import {
    getLatLonProjectionName, getViewProjection,
    getViewProjectionByName,
    getViewProjectionName
} from "@/helpers/ol/ol-projection-helper";
import VectorSource from "ol/source/Vector";
import {EsriJSON} from "ol/format";
import {tile} from "ol/loadingstrategy";
import {createXYZ} from "ol/tilegrid";
import VectorLayer from "ol/layer/Vector";
import {getWfsStyleFunction} from "@/modules/ol/service/ol-service-wfs";
import {scaleToResolution} from "@/helpers/ol/view/ol-view-resolutation-helper.js";

let token
/**
 * Add Web Map Service
 * @param map
 * @param service
 */
export function addServiceArcGisFeatureServer(map, service) {

    let serviceUrl = service.Url + '/' + service.Layer + '/FeatureServer/0'

    const source = new VectorSource({
        attributions: getLayerAttributes(service),
        format: new EsriJSON(),
        url: function (extent, resolution, projection) {
            // ArcGIS Server only wants the numeric portion of the projection ID.
            const srid = projection
                .getCode()
                .split(/:(?=\d+$)/)
                .pop();

            const url =
                serviceUrl +
                '/query/?f=json&' +
                'returnGeometry=true&spatialRel=esriSpatialRelIntersects&geometry=' +
                encodeURIComponent(
                    '{"xmin":' +
                    extent[0] +
                    ',"ymin":' +
                    extent[1] +
                    ',"xmax":' +
                    extent[2] +
                    ',"ymax":' +
                    extent[3] +
                    ',"spatialReference":{"wkid":' +
                    srid +
                    '}}',
                ) +
                '&geometryType=esriGeometryEnvelope&inSR=' +
                srid +
                '&outFields=*' +
                '&outSR=' +
                srid;

            return url;
        },
        strategy: tile(
            createXYZ({
                tileSize: 512,
            }),
        )
    });

    const layerOptions = {
        minResolution: scaleToResolution(service.MinResolution),
        maxResolution: scaleToResolution(service.MaxResolution),
        name: getLayerNamePrefix() + service.id,
        opacity: service.Opacity / 10,
        zIndex: service.zIndex,
        style: getWfsStyleFunction(service),
        source: source
    }

    const layer = new VectorLayer(layerOptions)

    map.addLayer(layer)

    removeLoaderByBookmarkPresentationID(service.id)

    return layer
}
